import IconArrowRight from "@/app/(site)/_components/Atoms/Icons/IconArrowRight"
import ButtonText from "../../../Molecules/ButtonText"
import DynamicLink from "../../../Molecules/Link"

type ShowAllPressroomArticlesProps = {
    title?: string
    url: string
}

export const ShowAllPressroomArticles = ({
    title,
    url
}: ShowAllPressroomArticlesProps) => (
    <DynamicLink href={url} prefetch={false}>
        <div className="flex aspect-square items-center justify-center rounded-full border border-black bg-main-black">
            <ButtonText
                className="flex items-center justify-center gap-8 text-main-white"
                icon={<IconArrowRight className="h-20 w-20" />}
                iconPosition="right"
                size="big"
                weight="regular"
            >
                <div className="!text-12 md:!text-16">{title}</div>
            </ButtonText>
        </div>
    </DynamicLink>
)
